import { Dispatch, SetStateAction, useState } from "react";

import { useTranslation } from "react-i18next";

import { TaskInfoOutlineIcon } from "@dotnet/telematics-design-system";

import { MenuAnchorEl } from "../../../../../../../shared";
import ListChoice from "../../../../../../ListChoice/ListChoice";
import { ScheduleDto } from "../../../../../types";

import ScheduleDetailsDialog from "./ScheduleDetailsDialog";

interface ScheduleDetailsProps {
  schedule: ScheduleDto;
  onActionsMenu: Dispatch<SetStateAction<MenuAnchorEl>>;
  isDriversPage?: boolean;
}

const ScheduleDetailsButton = ({
  schedule,
  onActionsMenu,
  isDriversPage
}: ScheduleDetailsProps) => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);

  const handleOpenScheduleDetailsDialog = () => {
    setIsOpen(true);
  };

  const handleCloseScheduleDetailsDialog = () => {
    setIsOpen(false);
    onActionsMenu(null);
  };

  return (
    <>
      <ListChoice
        title={t("Details##schedule details")}
        iconLeft={<TaskInfoOutlineIcon />}
        onClick={handleOpenScheduleDetailsDialog}
        alignIconCenter
      />

      <ScheduleDetailsDialog
        isDriversPage={isDriversPage}
        schedule={schedule}
        isOpen={isOpen}
        handleClose={handleCloseScheduleDetailsDialog}
      />
    </>
  );
};

export default ScheduleDetailsButton;
